module.exports = __webpack_public_path__ + "static/background1920-630d71f054c1c6626c7650e897054b62.png";